import { Modal, Result, Button } from 'antd';
import PublishIcon from '@mui/icons-material/Publish';
import { primaryShades } from '../../../theme/theme';

const ConfirmPublishDraftModal = ({
    visible,
    onCancel,
    onConfirm,
    catalogName,
    isPublishing = false
}) => {
    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            centered
            footer={null}
            maskClosable={!isPublishing}
        >
            <Result
                icon={<PublishIcon style={{ color: primaryShades.primary500, fontSize: 64 }} />}
                title="Publish Draft"
                subTitle={`Are you sure you want to publish this draft? This will move the draft to the published catalogues and make it available to users. A notification will be sent to confirm the publication.`}
                extra={[
                    <Button
                        key="publish"
                        type="primary"
                        onClick={onConfirm}
                        loading={isPublishing}
                        disabled={isPublishing}
                    >
                        Publish
                    </Button>,
                    <Button
                        key="cancel"
                        onClick={onCancel}
                        disabled={isPublishing}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmPublishDraftModal;
